export default __webpack_public_path__ + "static/media/TheVerge.15a5b993.svg";